module.exports = __webpack_public_path__ + "static/media/telit.a8860673.svg";